const defaults = {
    globals: {
        ibm: 'IBM',
        aspera: 'Aspera',
        aocTitle: 'IBM Aspera on Cloud - $0 - $1',
        aocOnPremTitle: 'IBM Aspera - $0 - $1',
        asperaTitle: 'IBM Aspera - $0 - $1',
        mobileTitle: 'IBM Aspera Mobile - $0 - $1',
        connectTitle: 'IBM Aspera Connect - $0 - $1',
        connectorTitle: 'IBM Aspera Connector - $0 - $1',
        desktopTitle: 'IBM Aspera for desktop - $0 - $1',
        testTitle: 'IBM Aspera - $0 - $1',
    },
    transferSystem: {
        unableToStartHttp: 'Unable to start Aspera HTTP Gateway',
        unableToStartConnect: 'Unable to start Aspera Connect SDK',
        unableToStartDesktop: 'Unable to start IBM Aspera desktop SDK',
        welcomeTo: 'Welcome to IBM $0',
        welcomeText: 'Send and share files up to a hundred times faster using our signature high-speed file transfer technology',
        welcomeTextToUseDesktop: 'We built a modern client application that enables you to transfer files at maximum speed. Install IBM Aspera for desktop to harness the full benefits of Aspera high speed transfers today!',
        welcomeContinue: 'Enable high speed transfer',
        welcomeSkip: 'Let me look around',
        installHeader: 'Get started now — install the IBM Aspera Connect transfer client.',
        installText: 'Install the $l/IBM Aspera Connect/$l client and the Aspera Connect browser plug-in to enable our signature high-speed file transfer technology.',
        updateHeader: 'Get started now — update the IBM Aspera Connect transfer client.',
        updateText: 'Update the $l/IBM Aspera Connect/$l client and the Aspera Connect browser plug-in to enable our signature high-speed file transfer technology.',
        ifYouSkip: 'If you skip installing, you might get prompted again to install Connect to start a transfer.',
        ifYouSkipWithHttp: 'If you skip installing, you will be able to use IBM Aspera HTTP Gateway for transfers; for faster transfers come back and install the app.',
        skipNow: "I'll skip for now",
        installExtension: 'Install extension',
        installExtensionHelp: 'Pre-requisite to install Connect',
        installExtensionButton: 'Install extension',
        installConnect: 'Install Connect client',
        installConnectHelp: 'Essential desktop app to make the transfer fast',
        installConnectButton: 'Install Connect',
        installTransferClient: 'Install transfer client',
        refreshPage: 'Refresh page',
        refreshPageHelp: 'After enabling extension refresh the page to load Connect',
        refreshPageButton: 'Refresh page',
        connectNotReadyToDownload: 'Connect is not ready to download',
        connectNotReadyToDownloadText: 'Please wait a few seconds and try again',
        desktopNotReadyToDownload: 'IBM Aspera is not ready to download',
        desktopNotReadyToDownloadText: 'Please wait a few seconds and try again',
        connectRequired: 'Transfer client required',
        toTransferInstallConnect: 'To transfer, you must install a transfer client',
        transferUnavailable: 'Transfer unavailable',
        transferSystemUnavailable: 'Transfer unavailable',
        noTransferSystemAvailable: 'No transfer system is available. Please try again later or contact your admin.',
        welcomeMobile: 'Transfer faster with the app',
        welcomeMobileText: 'IBM Aspera has all the features of the web UI, with faster transfers on your mobile device.',
        downloadApp: 'Download mobile app',
        launchApp: 'Open mobile app',
        useWeb: 'Use web version',
        mobileTransfers: 'Mobile transfers',
        mobileTransferStarted: 'Mobile transfer started',
        mobileTransfersHelper: 'Stay on this page until the transfer finishes.',
        default: 'Default',
        mobileAppRequired: 'Mobile app required',
        toTransferInstallMobileApp: 'To transfer, you must install the mobile app',
        asperaDesktopModalTitle: 'IBM Aspera for desktop',
        asperaDesktopModalInfo: 'Goodbye Connect, hello IBM Aspera for desktop! The new application can transfer your data at maximum speed without a web browser extension. You can also start and manage transfers within the app using a modern interface or link to an existing IBM Aspera account.',
        asperaDesktopModalInfoNew: "It's time to install IBM Aspera for desktop and enable high-speed transfers. IBM Aspera for desktop is a lightweight transfer application that allows you to transfer data at maximum speed using IBM Aspera's patented FASP protocol.",
        useIbmAsperaConnect: 'Keep using Connect',
        useIbmAsperaDesktop: 'Make the switch',
        unableConnectPreference: 'Unable to open client preferences',
        dialogError: 'Another dialog window is currently open',
        dialogErrorHelper: 'Check for an IBM Aspera dialog that may be open on this or another screen. Close the dialog and try again.',
        macUniversal: 'Apple macOS',
        windowsMSI: 'Microsoft Windows (x64)',
        linuxDeb: 'Linux (Debian)',
        linuxAppImage: 'Linux (AppImage)',
        unknownPlatform: 'Unknown platform',
        asperaDesktop: 'IBM Aspera for desktop',
        desktopSkip: 'Skip installing',
        asperaDesktopAbout: 'IBM Aspera for desktop is a modern client application that enables you to transfer files at maximum speed. With an intuitive interface, starting and managing transfers has never been easier.',
        installDesktopButton: 'Install now',
        alreadyHaveDesktop: 'Already have IBM Aspera for desktop?',
        launchDesktop: 'Launch now',
        minimize: 'Minimize',
        havingTrouble: 'Having trouble?',
        enableMultiUser: 'Enable multi-user mode',
        disableMultiUser: 'Disable multi-user mode',
        areYouSure: 'Are you sure?',
        installNow: 'Install now',
        skip: 'Skip',
        desktopAreYouSure: "Are you sure you don't want to install IBM Aspera for Desktop? The new app will replace Connect and will soon become a mandatory application for high speed transfers. Get ahead of the game — install now!",
        multiUserToolTip: 'Select this option when running IBM Aspera for desktop on a machine with other concurrent users also using the app.',
    },
    forms: {
        cancel: 'Cancel',
        submit: 'Submit',
        create: 'Create',
        save: 'Save',
        optional: 'optional',
        requireItem: 'This item is required',
        on: 'On',
        off: 'Off',
        chooseOption: 'Choose an option',
        hidePassword: 'Hide password',
        showPassword: 'Show password',
        invalidNumber: 'Invalid number selected',
        numberInfo: 'Increment/decrement number',
        increment: 'Increment number',
        decrement: 'Decrement number',
        unsavedChanges: 'You have unsaved changes!',
        unsavedChangesHeading: 'Unsaved changes',
        unsavedChangesDescription: 'If you leave, all unsaved changes will be lost.',
        stayOnThisPage: 'Stay on this page',
        leave: 'Leave',
        pickColor: 'Pick color',
        datePickerError: 'Date picker encountered an error',
    },
    lists: {
        noItemsAvailable: 'There are no items available',
        viewOptions: 'View options',
    },
    pageSystem: {
        loading: 'Loading',
    },
    header: {
        transferMonitor: 'Transfer monitor',
        help: 'Help',
        search: 'Search',
        notifications: 'Notifications',
        returnToMobileApp: 'Return to accounts',
        viewMobileDownloads: 'Downloads',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms and Conditions',
        thirdPartyNotices: 'Third Party Notices',
        about: 'About app',
        searchResults: 'Search results',
        searchNoResults: 'No results',
        unableToSearch: 'Unable to search',
        unableToSearchBody: 'Try changing your query or try again later',
        appSwitcher: 'App switcher',
        openLeftNav: 'Open left navigation',
        itemFailed: '$0 failed',
        itemCompleted: '$0 completed',
        itemTransferring: '$0 transferring',
        changeTheme: 'Change theme',
        theme: 'Theme',
        systemDefault: 'System default',
        darkMode: 'Dark mode',
        lightMode: 'Light mode',
        downloadSupportData: 'Download support data',
        getDebuggingInfo: 'Access debugging information',
        refresh: 'Refresh',
        resetSession: 'Reset session',
        default: 'Default',
        changeDefaultApp: 'Change default app',
        save: 'Save',
        defaultViewHeader: 'Change default view',
        defaultViewLabel: 'Configure your default view you want to see after logging in to $0.',
        dismissAll: 'Dismiss all',
        view: 'View',
    },
    user: {
        unknownUser: 'Unknown user',
        orgAdmin: 'Organization admin',
        workspaceAdmin: 'Workspace admin',
        atsAdmin: 'ATS admin',
        user: 'User',
        email: 'Email',
        standard: 'Standard',
        limited: 'Limited',
        deactivated: 'Deactivated',
        pending: 'Pending',
        active: 'Active',
        externalUser: 'External user',
    },
    userMenu: {
        logoutThirdParty: 'Log out of third party',
        logout: 'Log out',
        login: 'Log in',
        accountSettings: 'Account settings',
        appInfo: 'Application information',
    },
    transferActivity: {
        transferActivity: 'Transfer monitor',
        reloadConnect: 'Reload transfer client',
        allActivity: 'All activity',
        allStatus: 'All status',
        all: 'All',
        failed: 'Failed',
        paused: 'Paused',
        stopped: 'Stopped',
        completed: 'Completed',
        running: 'Running',
        upload: 'Upload',
        download: 'Download',
        noTransfersMessage: "You don't currently have any transfer activities.",
        noFilterResultsMessage: 'There are no transfers based on your filter',
        transfer: 'Transfer',
        uploadFailed: 'Upload failed',
        transferFailed: 'Transfer failed',
        transferCompleted: 'Transfer completed',
        uploading: 'Uploading...',
        uploaded: 'Uploaded',
        downloadFailed: 'Download failed',
        downloading: 'Downloading...',
        downloaded: 'Downloaded',
        transferring: 'Transferring...',
        queued: 'Queued',
        removed: 'Removed',
        cancelled: 'Cancelled',
        willRetry: 'Will retry transfer',
        partiallyCompleted: 'Partially completed',
        orphaned: 'Orphaned transfer',
        errorItem: 'Error: $0',
        unknownError: 'Unknown error',
        oneFile: '1 file',
        itemFiles: '$0 files',
        oneDay: '1day',
        itemDays: '$0days',
        oneHour: '1hour',
        itemHours: '$0hours',
        oneMin: '1min',
        itemMins: '$0mins',
        itemSeconds: '$0s',
        etaItem: 'ETA $0',
        cancel: 'Cancel',
        pause: 'Pause',
        resume: 'Resume',
        viewLocalFolder: 'View local folder',
        troubleshoot: 'Troubleshoot',
        clearInactiveTransfers: 'Clear inactive transfers',
        clearInactiveTransfersCount: 'Clear inactive transfers ($0)',
        installDesktopApp: 'Install the free desktop app',
        changeDownloadLocation: 'Change download location',
        dismiss: 'Dismiss',
        forceHttpGatewayUsage: 'Force to use Aspera HTTP gateway',
        httpTransfer: 'via IBM Aspera HTTP Gateway',
        nodeTransfer: 'Node to node transfer',
        removeTransfer: 'Remove transfer',
        pausing: 'Pausing',
        canceling: 'Canceling',
        resuming: 'Resuming',
        unableCancel: 'Unable to cancel transfer',
        unableResume: 'Unable to resume transfer',
        unableModify: 'Unable to modify transfer',
        unablePause: 'Unable to pause transfer',
        transferPaused: 'Transfer paused',
        transferCanceled: 'Transfer canceled',
        transferResumed: 'Transfer resumed',
        remoteTransferHelper: 'Remote transfers may take a few minutes to reflect changes. Transfer monitor will continue to check the transfer and show what is reported from the source.',
        openMobileApp: 'Open mobile app',
        installMobileApp: 'Install mobile app',
        changeTransferClient: 'Change transfer client',
        details: 'Details',
        unableLocalFolder: 'Unable to open local folder',
        unableLocalFolderHelper: 'The file may no longer exist or access to the file is limited.',
    },
    leftNav: {
        sideNavigation: 'Side navigation',
        sendFiles: 'Send files',
    },
    navItems: {
        home: 'Home',
        files: 'Files',
        packages: 'Packages',
        admin: 'Admin',
        automation: 'Automation',
        faspio: 'faspio',
        public: 'Public access',
        activity: 'Activity',
        settings: 'Account settings',
        help: 'Help center',
    },
    bytes: {
        bitExaPsAbb: 'Ebps',
        bitGigaPsAbb: 'Gbps',
        bitKiloPsAbb: 'Kbps',
        bitMegaPsAbb: 'Mbps',
        bitPetaPsAbb: 'Pbps',
        bitPsAbb: 'bps',
        bitTeraPsAbb: 'Tbps',
        byteAbb: 'B',
        byteExaAbb: 'EB',
        byteExaPsAbb: 'EBps',
        byteGigaAbb: 'GB',
        byteGigaPsAbb: 'GBps',
        byteKiloAbb: 'KB',
        byteKiloPsAbb: 'KBps',
        byteMegaAbb: 'MB',
        byteMegaPsAbb: 'MBps',
        bytePetaAbb: 'PB',
        bytePetaPsAbb: 'PBps',
        bytePsAbb: 'Bps',
        byteTeraAbb: 'TB',
        byteTeraPsAbb: 'TBps',
    },
    table: {
        previousPage: 'Previous page',
        firstPage: 'First page',
        nextPage: 'Next page',
        itemsPerPage: 'Items per page',
        pageItem: 'Page $0',
        pageRange: 'of $0 page',
        pagesRange: 'of $0 pages',
        rangeOfTotal: '$0-$1 of $2 items',
        unableToLoad: 'Unable to load this data',
        unableToLoadDescription: 'Try to refresh or change your query',
        emptyTable: 'No items exist',
        emptyTableDescription: 'Create a new item to see content here',
        selectRow: 'Select row',
        unknown: 'Unknown',
        selectAll: 'Select all',
        itemItemsSelected: '$0 items selected',
        itemSelected: '$0 selected',
        back: 'Back',
        filterTable: 'Filter table',
        search: 'Search',
        moving: 'Moving',
        copying: 'Copying',
        holdAltToCopy: 'Hold $b/ALT/$b to copy',
        holdAltToMove: 'Hold $b/ALT/$b to move',
        expandRow: 'Expand row',
        editColumns: 'Edit columns',
        noMorePages: 'This set of data has no more pages',
        noMorePriorPages: 'Unable to go back. Try reloading the data',
        advancedFilters: 'Advanced filters',
        apply: 'Apply',
        resetAdvancedFilters: 'Reset advanced filters',
        cancel: 'Cancel',
        options: 'Options',
        pageNumber: 'Page number',
        itemText: '$0-$1 items',
        pageLabel: 'Page number, of $0 pages',
        refreshTable: 'Refresh table',
        resetTable: 'Reset table',
        clearSearch: 'Clear search',
        more: 'More',
        actions: 'Actions',
        filters: 'Filters',
        menu: 'Menu',
    },
    errors: {
        pageNotFound: 'Page not found',
        pageNotFoundDescription: 'The page you requested could not be found.',
        genericError: 'App encountered an error',
        genericErrorDescription: 'The app encountered an error trying to load the needed resources.',
        noAccessToSystem: 'You do not have access to this system',
        noAccessToSystemDescription: 'Contact your admin to get access this system',
        noAccessToApp: 'You do not have access to $0',
        noAccessToAppDescription: 'Contact your admin to get access to this app',
        noAccessToGeo: 'You do not have access to due to your current location',
        noAccessToGeoDescription: "We're sorry, but you do not have access permissions. Please contact your organization admin.",
    },
    group: {
        local: 'Local',
        saml: 'SAML',
        group: 'Group',
    },
    memberships: {
        member: 'Member',
        workspaceManager: 'Workspace manager',
        inherited: 'Inherited',
        direct: 'Direct',
        directAndInherited: 'Direct and inherited',
    },
    modal: {
        close: 'Close',
        modalDescription: 'Root of a modal content containing interactive items',
        submit: 'Submit',
        cancel: 'Cancel',
        typeToConfirm: "Type '$0' to confirm",
        typeToConfirmError: "You must type in '$0' to continue.",
    },
    autocomplete: {
        loading: 'Loading...',
        noResults: 'No results',
        error: 'Unable to retrieve items',
        cannotFindWhatLookingFor: "Can't find what you're looking for?",
        createAndAdd: 'Create and add',
        addedList: 'Selected',
    },
    sendPackage: {
        instructions: 'Instructions',
        bcc: 'Bcc',
        sendNotifications: 'Notifications',
        packageTitle: 'Title',
        packageMessage: 'Message',
        addFiles: 'Add files',
        files: 'Files',
        folders: 'Folders',
        unableAddFilesFolders: 'Unable to add items',
        dropFilesText: 'Drag and drop files here to add content',
        scheduleForLater: 'Schedule for later',
        passwordProtectionHelper: 'Setting a password for your package will require recipients to enter it to decrypt its contents. This password is not sent through IBM Aspera.',
        passwordProtection: 'Password protection',
        expirationPolicy: 'Expiration policy',
        deleteByDownload: 'Delete files by download records',
        deleteByTime: 'Delete files by time',
        moreTransferOptions: 'More transfer options',
        password: 'Password',
        confirmPassword: 'Confirm password',
        passwordMustMatch: 'Passwords must match',
        obfuscationFileName: 'Mask file names',
        preventHttpDownload: 'Require recipients to download the package using Connect',
        preventHttpDownloadTooltip: 'Enabling this setting prevents users from downloading the package using IBM Aspera HTTP Gateway or HTTP fallback.',
        releaseNow: 'Release now',
        releaseLater: 'Release later',
        releaseDate: 'Release date',
        setReleaseDateLater: 'Set release date later',
        chooseTime: 'Choose a time',
        removeFile: 'Remove file',
        none: 'None',
        deleteAfterAnyDownloadsAll: 'Delete after any recipient downloads all files',
        deleteAfterAllDownloadsAll: 'Delete after all recipients download all files',
        never: 'Never',
        inTwentyFourHours: 'In 24 hours',
        inSevenDays: 'In 7 days',
        inThirtyOneDays: 'In 31 days',
        custom: 'Custom',
        customDate: 'Custom date',
        removeAll: 'Remove all',
        applyWatermarking: 'Apply watermarking',
        applyWatermarkingHelper: 'Watermarking will fail for packages that include unsupported file types. Supported file types: TS, PS, MPG, MPEG, MOV, MXF, MP4.',
        helperTextIllegalChar: 'Illegal characters: $0',
        helperTextMaxLength: 'Max length: $0',
        errorTextIllegalChar: 'Invalid characters used. $0',
        pathInfo: 'Path: $0',
        sizeInfo: 'Size: $0',
        lastModifiedInfo: 'Last modified: $0',
        info: 'Info',
        tooManyFiles: 'Plus $0 more files not rendered (but will be transferred).',
        unableAddFiles: 'Unable to add some files',
        unableAddFilesHelper: 'The following files have the same name as files already in this package: $0. Rename the files and try adding again.',
    },
    imagePicker: {
        addFile: 'Add file',
        image: 'Image',
        remove: 'Remove',
        invalidFileType: 'Invalid file type',
        onlyImagesSupported: 'Only images are supported',
        unableToProcessImage: 'Unable to process image',
        fileTooBig: 'The selected file is too large',
        dropImageHere: 'Drop image here',
    },
    reorder: {
        moveUp: 'Move item up',
        moveDown: 'Move item down',
    },
    breadcrumbs: {
        viewBreadcrumbs: 'View breadcrumbs',
    },
    modalAppInfo: {
        heading: 'Aspera Application Information',
        subHeading: 'Find useful information about the current application and debug data',
        appData: 'Application data',
        sessionErrors: 'Session errors',
        errorName: 'Error name',
        consoleError: 'Send to console',
        viewError: 'View error',
        consoleAllErrors: 'Send all to console',
        consoleInstructions: 'Find the most recent errors and logs below. Click the View icon to display and copy basic data. Click the Debug icon to send detailed data to the browser console or to provide to your Support engineer.',
        appName: 'App name',
        webVersion: 'UI version',
        hash: 'UI hash',
        userAgent: 'User agent',
        apiLocation: 'API Location',
        libraryVersion: 'Library version',
        serverVersion: 'Server version',
        connectServer: 'Connect server',
        connectMinServer: 'Connect min version',
        connectMethod: 'Connect method',
        httpGatewayServer: 'HTTP Gateway server',
        medalliaEnabled: 'Medallia enabled',
        segmentEnabled: 'Segment enabled',
        yes: 'Yes',
        no: 'No',
        currentLanguage: 'Current language',
        currentTransferSystem: 'Current transfer system',
        runningConnectVersion: 'Connect app version',
        connectStatus: 'Connect Status',
        runningHttpServerVersion: 'Aspera HTTP Gateway version',
        transferConnect: 'IBM Aspera Connect',
        transferDesktop: 'IBM Aspera for desktop',
        transferHttp: 'IBM Aspera HTTP Gateway',
        transferMobile: 'IBM Aspera mobile',
        none: 'None',
        unknown: 'Unknown',
        unableToViewError: 'Unable to view error',
        unableToViewErrorHelper: 'Use console to debug this error',
        date: 'Date',
        noErrors: 'No errors',
        noErrorsBody: 'If errors occur while using the app they will be listed here and can be exported to provide to IBM support.',
    },
    modalDecrypt: {
        decryptItems: 'Decrypt items',
        decrypt: 'Decrypt',
        skip: 'Skip',
        decryptItemsDescription: 'This transfer contains encrypted files.',
        decryptItemsWarning: 'Enter the decryption passphrase or you can retain encryption and apply the password later using the IBM Aspera client.',
        passphrase: 'Passphrase',
        passphraseAccepted: 'Passphrase used for transfer',
    },
    notifications: {
        copied: 'Copied',
        sessionExpiresMinutes: 'For security purposes, your admin requires all users to authenticate periodically. Your current session is set to expire in $b/$0 minutes/$b.',
        sessionExpiresLessThanMinutes: 'For security purposes, your admin requires all users to authenticate periodically. Your current session is set to expire in $b/less than a minute/$b.',
        reAuthenticate: 'Re-authenticate',
        sessionExpireSoon: 'Your session will expire soon',
        staySignedIn: 'Stay signed in',
        signOut: 'Sign out',
        inactivityInfo: "You will be logged out of your current session due to inactivity. Click 'Stay signed in' to continue or 'Sign out' if you're done.",
        sessionMayHaveExpired: 'Your session may be expired',
        sessionMayHaveExpiredInfo: 'Your session may be expired now. Reload the app to restart your session.',
        reload: 'Reload',
    },
    timePicker: {
        hourMinute: 'hh:mm',
        hourMinuteLocalTimezone: 'hh:mm (local timezone)',
        am: 'AM',
        pm: 'PM',
        invalidTime: 'Time is invalid',
    },
    timezone: {
        timeN720: 'Etc/GMT-12',
        timeN660: 'Pacific/Midway',
        timeN600: 'America/Adak',
        timeN540: 'America/Anchorage',
        timeN480: 'America/Los Angeles',
        timeN420: 'America/Denver',
        timeN360: 'America/Chicago',
        timeN300: 'America/New York',
        timeN270: 'America/Caracas',
        timeN240: 'America/Campo Grande',
        timeN180: 'America/Argentina/Buenos Aires',
        timeN210: 'America/St Johns',
        timeN120: 'America/Noronha',
        timeN60: 'Atlantic/Cape Verde',
        time0: 'Europe/London',
        time60: 'Europe/Amsterdam',
        time120: 'Africa/Cairo',
        time180: 'Africa/Addis Ababa',
        time210: 'Asia/Tehran',
        time240: 'Europe/Moscow',
        time270: 'Asia/Kabul',
        time300: 'Asia/Tashkent',
        time330: 'Asia/Kolkata',
        time345: 'Asia/Katmandu',
        time360: 'Asia/Dhaka',
        time390: 'Asia/Rangoon',
        time420: 'Asia/Bangkok',
        time480: 'Asia/Hong Kong',
        time525: 'Australia/Eucla',
        time540: 'Asia/Tokyo',
        time570: 'Australia/Darwin',
        time600: 'Australia/Brisbane',
        time630: 'Australia/Lord Howe',
        time660: 'Asia/Vladivostok',
        time690: 'Pacific/Norfolk',
        time720: 'Pacific/Auckland',
        time765: 'Pacific/Chatham',
        time780: 'Pacific/Tongatapu',
        time840: 'Pacific/Kiritimati',
    },
    refreshPageModal: {
        needToReload: 'You must refresh this page to apply your changes.',
        caution: 'Caution:',
        needToReloadHelper: 'Refreshing the page interrupts in-progress IBM Aspera HTTP Gateway uploads.',
        reloadApplication: 'Refresh page?',
        reload: 'Refresh',
        close: 'Close',
    },
    httpWarningModal: {
        title: 'Session ended with transfers still in progress',
        subtext: 'Wait for these Aspera HTTP Gateway transfers to complete before refreshing or closing this page.',
    },
    downloadAsCsv: {
        saveTable: 'Download table',
        saveTableRaw: 'Download raw data',
        title: 'Download table as CSV',
        download: 'Download',
        downloadReady: 'The file is now ready to download.',
        downloadWorking: 'The file is being prepared. This may take several minutes depending on size.',
    },
    faspio: {
        faspio: 'faspio',
        description: 'Manage and create bridges for your gateways',
        name: 'Name',
        bridgeSaved: 'Bridge saved',
        bridgeUnableSave: 'Unable to save bridge',
        forward: 'Forward',
        local: 'Local',
        save: 'Save',
        create: 'Create',
        host: 'Host',
        hostHelper: 'IP or hostname, do not include protocol or port.',
        hostError: 'Invalid host. Host should be an IP address or hostname and should not include the protocol or port',
        protocol: 'Protocol',
        tcp: 'TCP',
        udp: 'UDP',
        fasp: 'FASP',
        tlsEnabled: 'Enable TLS',
        protocolError: 'Local TCP cannot forward to UDP or vice versa',
        portForwarding: 'Port forwarding',
        createNew: 'Create new',
        delete: 'Delete',
        deleteUnable: 'Unable to delete bridges',
        deleteSuccess: 'Bridges deleted',
        confirmDeleteTitle: 'Delete faspio bridges?',
        actionCannotUndone: 'This cannot be undone.',
        confirmDeleteDescription: 'Are you sure you want to delete the following faspio bridges?',
        addPortForwarding: 'Add port forwarding',
        add: 'Add',
        localPort: 'Local port',
        forwardPort: 'Forward port',
        portForwardItem: 'Port $0 forwarded to $1',
        remove: 'Remove',
    },
    fontFamilies: {
        helvetica: 'Helvetica (sans-serif)',
        arial: 'Arial (sans-serif)',
        arialBlack: 'Arial Black (sans-serif',
        verdana: 'Verdana (sans-serif)',
        tahoma: 'Tahoma (sans-serif)',
        trebuchet: 'Trebuchet MS (sans-serif)',
        impact: 'Impact (sans-serif)',
        gillSans: 'Gill Sans (sans-serif)',
        timesNewRoman: 'Times New Roman (serif)',
        georgia: 'Georgia (serif)',
        palatino: 'Palatino (serif)',
        baskerville: 'Baskerville (serif)',
        andaleMono: 'Andalé Mono (monospace)',
        courier: 'Courier (monospace)',
        lucidaConsole: 'Lucida Console (monospace)',
        monaco: 'Monaco (monospace)',
        bradleyHand: 'Bradley Hand (cursive)',
        brushScript: 'Brush Script MT (cursive)',
        luminari: 'Luminari (fantasy)',
        comicSans: 'Comic Sans MS (cursive)',
    },
    customThemeForm: {
        font: 'Font',
        fontHelper: 'Customize the font that will be used in the UI.',
        defaultFont: 'Default (IBM Plex)',
        header: 'Header',
        headerBackground: 'Header background',
        headerTextIcon: 'Header text and icons',
        headerAccentBorders: 'Header accent borders',
        headerActiveItemBackground: 'Header active item background',
        headerActiveItemColor: 'Header active item color',
        headerItemHoverBackground: 'Header item hover background',
        leftNav: 'Left navigation',
        leftNavBackground: 'Left nav background',
        leftNavTextColor: 'Left nav text color',
        leftNavItemActiveBackground: 'Left nav item active background',
        leftNavItemActiveBackgroundAccent: 'Left nav item active background accent',
        leftNavItemHoverBackground: 'Left nav item hover background',
        buttons: 'Buttons',
        buttonsHelper: 'Some special buttons may require changing Advanced design tokens below.',
        buttonPrimaryBackground: 'Primary button background',
        buttonPrimaryText: 'Primary button text',
        buttonPrimaryHoverBackground: 'Primary button hover background',
        buttonPrimaryActiveBackground: 'Primary button active background',
        buttonSecondaryBackground: 'Secondary button background',
        buttonSecondaryText: 'Secondary button text',
        buttonSecondaryHoverBackground: 'Secondary button hover background',
        buttonSecondaryActiveBackground: 'Secondary button active background',
        buttonTertiaryBorder: 'Tertiary button border',
        buttonTertiaryText: 'Tertiary button text',
        buttonTertiaryTextStates: 'Tertiary button text for hover and active states',
        buttonTertiaryHoverBackground: 'Tertiary button hover background',
        buttonTertiaryActiveBackground: 'Tertiary button active background',
        advanced: 'Advanced design tokens',
        advancedHelper: 'You can change all UI design tokens to fully customize the application. Please refer to documentation to understand each design token.',
        themes: 'Themes',
        themeHelper: 'Customize the light and dark theme of the application, or lock the application to a single custom theme.',
        enableLightDarkThemes: 'Enable light and dark custom themes',
        lightTheme: 'Light theme',
        darkTheme: 'Dark theme',
        preview: 'Preview',
        import: 'Import',
        export: 'Export current settings',
        unableImport: 'Unable to import',
        invalidJson: 'Invalid JSON content for theme import',
        hideDesignTokens: 'Hide design tokens',
        showDesignTokens: 'Show design tokens',
        seeDocumentation: 'See documentation',
        primaryButton: 'Primary button',
        secondaryButton: 'Secondary button',
        tertiaryButton: 'Tertiary button',
        seeLegend: 'See legend',
        legend: 'Legend',
        themeEditor: 'Theme editor',
        themeEditorHelper: "Customize the UI to personalize the experience. Import or export a custom theme to use in other IBM Aspera apps or systems. Files must be in JSON format with the '.json' extension.",
        setToDefault: 'Reset to default',
        loginPages: 'Login page',
        loginPanelBackgroundColor: 'Panel background color',
        loginPanelTextColor: 'Panel text color',
        loginInPanelAnnouncementBackgroundColor: 'Announcement background color (in panel)',
        loginInPanelAnnouncementTextColor: 'Announcement text color (in panel)',
        loginAnnouncementBackgroundColor: 'Announcement background color (floating)',
        loginAnnouncementBackgroundTextColor: 'Announcement text color (floating)',
    },
    numberUnitInput: {
        units: 'Units',
        seconds: 'Seconds',
        minutes: 'Minutes',
        hours: 'Hours',
        days: 'Days',
        weeks: 'Weeks',
    },
    customBrandingForm: {
        previewLoginPage: 'Preview login page',
        customLogo: 'Custom logo',
        customLogoHelperDefault: 'Upload an image to be displayed on the login page. (500 KB max).',
        customBackgroundImage: 'Custom background image',
        customBackgroundImageHelperDefault: 'Upload a custom background image to be displayed on the login page. (4 MB max).',
        previewInApp: 'Preview logo',
        inAppLogoCustomization: 'Header logo',
        inAppLogoCustomizationHelper: 'Customize the logo that will be displayed on the header.',
        default: 'Default',
        customText: 'Custom text logo',
        customImage: 'Custom image logo',
        customTextImage: 'Custom text and image',
        inAppTextMode: 'Custom text to be displayed as a logo on the header.',
        inAppImageMode: 'Custom image to be displayed as logo on the header. We recommend a rectangular image. (500 KB max).',
        inAppTextImageMode: 'Custom image and text to be displayed as logo on the header. We recommend a square image. (500 KB max).',
        customLogoHere: 'Your custom logo image goes here.',
        customBackgroundHere: 'Your custom background image goes here.',
        customAppTextHere: 'Your custom text logo goes here.',
        customAppImageHere: 'Your custom image logo goes here.',
        customAppTextImageHere: 'Your custom image and text logo goes here.',
        layout: 'Layout',
        loginScreenLayout: 'Login screen layout',
        leftAligned: 'Left aligned (Default)',
        centerAligned: 'Center aligned',
        announcementPanel: 'Announcement panel (optional)',
        announcementPanelHelper: 'Write a custom message to display on the login page. Use Markdown to format it.',
        announcement: 'Announcement',
        announcementOne: 'Announcement panel 1 title',
        announcementOneMessage: 'Announcement panel 1 message',
        announcementTwo: 'Announcement panel 2 title',
        announcementTwoMessage: 'Announcement panel 2 message',
        addAdditionalPanel: 'Add additional panel',
        customizeLoginTheme: 'Customize login screen theme',
        customizeLoginThemeHelper: 'Customize the login screen UI colors in the Theme editor tab.',
        customizeTheme: 'Customize theme',
        customBackgroundPosition: 'Custom background position',
        customBackgroundPositionHelper: 'Set the position of the background image shown on the login page. The first value is the horizontal position and the second value is vertical position.',
        centerBottom: 'Center bottom',
        centerCenter: 'Center center',
        centerTop: 'Center top',
        leftBottom: 'Left bottom',
        leftCenter: 'Left center',
        leftTop: 'Left top',
        rightBottom: 'Right bottom',
        rightCenter: 'Right center',
        rightTop: 'Right top',
    },
    feedbackModal: {
        title: 'Send feedback to IBM',
        name: 'Name',
        email: 'Email',
        emailIsInvalid: 'Email is invalid',
        feedback: 'Feedback',
        includeDebuggingData: 'Include debug and app data',
        send: 'Send',
        feedbackUnable: 'Unable to submit feedback',
        feedbackSubmitted: 'Feedback submitted',
    },
    transferInfo: {
        title: 'Title',
        added: 'Time added',
        app: 'Application',
        asperaOnCloud: 'IBM Aspera on Cloud - $0',
        asperaOnCloudOnPrem: 'IBM Aspera - $0',
        asperaEnterprise: 'IBM Aspera - $0',
        otherWebApp: 'Other web application',
        status: 'Status',
        dataExpected: 'Data expected',
        dataWritten: 'Data written',
        rate: 'Rate',
        ended: 'Time ended',
        currentFile: 'Current file',
        transport: 'Transport',
        fasp: 'FASP',
        http: 'HTTP',
        uuid: 'UUID',
        remoteHost: 'Remote host',
        remoteAccessKey: 'Remote access key',
        remoteUser: 'Remote user',
        cipher: 'Cipher',
        sshPort: 'SSH port',
        faspPort: 'FASP port',
        multiSessionThreshold: 'Multi-session threshold',
        multiSession: 'Multi-session count',
        files: 'Files',
        filesAttempted: 'Files attempted',
        filesCompleted: 'Files completed',
        filesFailed: 'Files failed',
        filesSkipped: 'Files skipped',
        transferSpec: 'Transfer specification',
        fullTransfer: 'Full transfer',
        errorDescription: 'Error description',
        errorCode: 'Error code',
        percent: 'Percent',
        speedTargetRate: 'Target rate (Mbps)',
        transferSpeed: 'Transfer speed',
        transferInfo: 'Transfer info',
        percentItem: '$0%',
        rateUnableChange: 'Your maximum target rate is set at $0.',
    },
    desktopClientRedirect: {
        title: 'Click $b/Allow/$b on any prompt that appears.',
        subTitle: 'Click $b/Launch IBM Aspera/$b if no prompt appears or the app is not opened.',
        launchIbmAspera: 'Launch IBM Aspera',
        titleLoaded: 'IBM Aspera has started!',
        subTitleLoaded: 'You may now close this window.',
        supportHelp: 'Having trouble? $l/Open IBM Aspera support/$l.',
    },
};
export default defaults;
